import script from "./ModalWingoResult.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalWingoResult.vue?vue&type=script&setup=true&lang=js"

import "./ModalWingoResult.vue?vue&type=style&index=0&id=50da7628&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50da7628"]])

export default __exports__